module.exports = __webpack_public_path__ + "img/toggleDisabled.f8c77c46.svg";